<template>
  <b-badge
    v-if="activeFilterCount > 0"
    variant="primary"
    class="rounded-circle d-inline-flex justify-content-center align-items-center badge-pulse"
    style="width: 20px; height: 20px; padding: 0;"
    v-bind="$attrs"
  >
    {{ activeFilterCount }}
  </b-badge>
</template>

<style scoped>
@keyframes pop-and-ripple {
  0% {
    transform: scale(0.5);
    box-shadow: 0 0 0 0 rgba(115, 103, 240, 0.8);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 0 6px rgba(115, 103, 240, 0.4);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 12px rgba(115, 103, 240, 0);
  }
}

.badge-pulse {
  animation: pop-and-ripple 1.5s ease-out;
  animation-iteration-count: 3;
}
</style>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'ActiveFilterCount',
  components: {
    BBadge,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    activeFilterCount() {
      if (!this.filters) return 0
      let count = 0
      Object.entries(this.filters).forEach(([key, value]) => {
        if (value) {
          if (key === 'orders.created_at' || key === 'status_date') {
            if (value.startDate && value.endDate) {
              count += 1
            }
          } else if (typeof value === 'boolean') {
            if (value) count += 1
          } else if (typeof value === 'string' && value.trim() !== '') {
            count += 1
          } else if (Array.isArray(value) && value.length > 0) {
            count += 1
          } else if (typeof value === 'number') {
            count += 1
          }
        }
      })
      return count
    },
  },
}
</script>
